import { computed } from "vue";

import { useViewState } from "./useViewState";
import { useEmployeeDirectoryViewState } from "../../EmployeeDirectory/composables/useViewState";

export function useTableConfig() {
  const viewState = useViewState();
  const viewEmployeeDirectoryViewState = useEmployeeDirectoryViewState();

  const tableParams = computed(() => {
    return {
      headers: [
        {
          text: "Badge",
          sortable: true,
          value: "badge",
          width: "100px",
        },
        {
          text: "Responsibility",
          sortable: true,
          value: "responsibility",
        },
        {
          text: "Issued By/On",
          sortable: true,
          value: "issued_by/on",
          width: "150px",
        },
      ],
      columns: [
        {
          field: "",
          component: "ReadinessBadge",
          props: (item) => ({
            class: "my-4",
            ...viewState.getReadinessBadgeProps(item),
          }),
          events: () => ({}),
        },
        {
          field: "",
          component: "OrgObjectCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getOrgObjectCardProps(item),
          }),
        },
        {
          field: "",
          component: "EvalEmpCard",
          props: (item) => ({
            class: "my-4",
            ...viewState.getEvalEmpCardProps(item),
          }),
        },
      ],
      filters: {
        values: viewState.state.filters.values,
        searchText: viewState.state.filters.searchText,
      },
      hideTopSection: true,
      hideActiveNo: false,
      activeRecords: {
        field: "current_status",
        value: "active",
      },
      actionLabel: "Recalculate All",
      showActionButton: viewState.state.filters.needsRecalculation
        ? false
        : true,
      must: viewState.state.filters.needsRecalculation ? true : false,
      hideGridView: true,
      hideButtonIcon: true,
      title: "Employees Readiness",
      hideButtonInMessage: true,
      hideFilterBtn: true,
      showLevelCounter: true,
      levelCounter: {
        apprentice: 0,
        professional: 0,
        coach: 0,
        master: 0,
      },
      getRowStyle: (item) => ({
        backgroundColor:
          item.position?.data?.status === "active" ? "#ECFDF3" : "#FFFFFF",
      }),
      showBreadCrumbs: true,
      breadcrumbItems: [
        { text: "Employee Directory", disabled: false },
        {
          text: `${
            viewEmployeeDirectoryViewState?.state?.selectedEmployee
              ?.first_name +
            " " +
            viewEmployeeDirectoryViewState?.state?.selectedEmployee?.last_name
          }`,
          disabled: false,
        },
        { text: "Badges", disabled: true, href: "" },
      ],
      levelFilterCounter: [],
    };
  });
  return {
    tableParams,
  };
}
